












import { Component, Vue, Prop } from 'vue-property-decorator';
import { GQL_order_order_logo } from '@/queries/__generated__/order';
import { GQL_paycheckForm_paycheck_logo } from '@/queries/__generated__/paycheckForm';

@Component
export default class DocumentLogo extends Vue {
  @Prop(Object) public logo!: GQL_order_order_logo | GQL_paycheckForm_paycheck_logo;
}
